var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":"","id":"main-container"}},[_c('p',[_vm._v(" "+_vm._s(_vm.admin)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }